// Colors used by the canvas renderer. The DOM panels use the matching CSS
// custom properties in src/styles/main.css.

export const COLORS = {
  wheat: '#e2ab48',
  hubLabel: '#c9a15b',
  predict: '#5fb3c7',       // pre-flight predicted conflict
  predictInk: '#bfe6ee',
  predictGlow: 'rgba(95,179,199,0.22)', // urgent predicted-conflict halo
  ground: '#b29be0',        // grounded by wind
  alert: 'rgba(209,97,74,0.85)', // airborne separation alert
  selection: '#eee3c8',
  ghost: 'rgba(238,227,200,0.38)',       // previewed (not yet applied) reroute
  ghostStrong: 'rgba(238,227,200,0.85)', // ...while hovered, focused or dragged
  label: 'rgba(236,223,196,0.7)',
  grid: 'rgba(111,160,90,0.08)',
  fieldFill: 'rgba(111,160,90,0.07)',
  fieldStroke: 'rgba(111,160,90,0.28)',
  fieldLabel: 'rgba(180,196,182,0.55)',
  hubFill: 'rgba(226,171,72,0.14)',
  holdRing: 'rgba(226,171,72,0.5)',
  windRing: 'rgba(95,179,199,0.5)',
  // base palette, same values as the CSS tokens in src/shared/tokens.css
  ink: '#ecdfc4',
  dim: '#82938d',
  dusk: '#141f26',
  dusk2: '#1c2b33',
  crop: '#6fa05a',
  cyan: '#5fb3c7',
  alertSolid: '#d1614a',
  alertInk: '#f3c6ba',
  frame: 'rgba(130,147,141,0.28)', // edge of the playable area (phone)
  // crop-dusting operations (#13)
  toScout: 'rgba(226,171,72,0.55)',     // work-order field not scouted yet
  sweepLine: 'rgba(95,179,199,0.75)',   // a scout's completed passes
  sprayBand: 'rgba(143,191,120,0.32)',  // sprayed lanes
  sprayedFill: 'rgba(111,160,90,0.14)', // a fully sprayed field
  ownRing: 'rgba(236,223,196,0.55)',    // marks the farmer's own aircraft
  blipStroke: 'rgba(10,15,18,0.85)',
};

export const MONO = "'IBM Plex Mono', ui-monospace, monospace";
export const DISPLAY = "'Chakra Petch', ui-sans-serif, system-ui, sans-serif";

/** `#rrggbb` plus an alpha (0..1) as an 8-digit hex color. */
export function withAlpha(hex, alpha) {
  const a = Math.round(Math.max(0, Math.min(1, alpha)) * 255).toString(16).padStart(2, '0');
  return `${hex.slice(0, 7)}${a}`;
}
